import * as yup from 'yup';

export const validationSchema = yup.object({
  url: yup.string().required('Required'),
  auth_token: yup.string(),
  events: yup.array().of(yup.object()).nullable().required('Required')
});
